module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_kifu-3b34855bcc73eeaaa41e5b2d69395006.jpg";